import { render, staticRenderFns } from "./WholesalerSelect.vue?vue&type=template&id=fec1fe6e&scoped=true"
import script from "./WholesalerSelect.vue?vue&type=script&lang=js"
export * from "./WholesalerSelect.vue?vue&type=script&lang=js"
import style0 from "./WholesalerSelect.vue?vue&type=style&index=0&id=fec1fe6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec1fe6e",
  null
  
)

export default component.exports